import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function Hope() {
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>
              El yurt umidi     
              </h4>
            </div>
            <p>
              2018 yil 25 sentyabr. O‘zbekiston Respublikasi Prezidentining
              PF-5545-sonli “O‘zbekiston Respublikasi Vazirlar Mahkamasi
              huzuridagi Mutaxassislarni xorijda tayyorlash va vatandoshlar
              bilan muloqot qilish bo‘yicha “El-yurt umidi” jamg‘armasi
              faoliyatini tashkil etish to‘g‘risida” Farmonining qabul
              qilinishi.
            </p>

            <p>
              O‘zbekiston Respublikasi Prezidentining 1997 yil 7 yanvardagi
              PF-1694-sonli «O‘zbekiston Respublikasi Prezidentining iqtidorli
              yoshlarning chet elda ta'lim olishlarini qo‘llab-quvvatlash «Umid»
              jamg‘armasini tuzish to‘g‘risida»gi Farmoni asosida “Umid”
              jamg‘armasi tashkil etilgan. Mazkur jamg‘arma 1997-2003 yillar
              mobaynida dunyoning eng ilg‘or G7 davlatlari qatoriga kiruvchi
              AQSh, Kanada, Buyuk Britaniya, Fransiya, Germaniya, Italiya va
              Yaponiya davlatlarida davlatlarida jami 828 nafar stipendiatlarni
              bakalavriat va magistratura ta'lim yo‘nalishlarida o‘qitgan.
            </p>

            <p>
              O‘zbekiston Respublikasi Prezidentining 2003 yil 1 iyuldagi
              PF-3272-sonli «Istiqbolli yosh pedagoglarni va ilmiy kadrlarni
              malakasini oshirish va tajriba orttirish tizimini
              takomillashtirish to‘g‘risida»gi Farmoniga asosan “Umid” va
              “Ustoz” jamg‘armalari negizida “Iste'dod” jamg‘armasi tuzilgan.
              Mazkur jamg‘arma 2003-2018 yillar mobaynida dunyoning eng ilg‘or
              davlatlarida jami 914 nafar stipendiatlarni stajirovka va malaka
              oshirish ta'lim yo‘nalishlarida o‘qitgan.
            </p>

            <p>
              2018 yil 25 oktyabr'. O‘zbekiston Respublikasi Prezidentining
              PQ-3982-sonli “Xorijda istiqomat qilayotgan vatandoshlar bilan
              hamkorlik sohasida O‘zbekiston Respublikasi davlat siyosatini
              yanada takomillashtirish choralari to‘g‘risida” qarorining qabul
              qilinishi.
            </p>

            <p>
              Mazkur qarorga muvofiq “El-yurt umidi” jamg‘armasiga xorijda
              istiqomat qilayotgan, zamonaviy bilim va boy amaliy tajribaga ega
              bo‘lgan vatandoshlar bilan muloqotni yanada kuchaytirish, ularni
              O‘zbekistonga turli nufuzli lavozimlarga ishga taklif etish,
              ularning salohiyatidan O‘zbekistonning xalqaro maydondagi ijobiy
              nufuzini yanada mustahkamlashda samarali foydalanishga
              ko‘maklashish, shuningdek, shunday tadbirlarni moliyalashtirish
              vazifasi yuklatilgan.
            </p>
            <p>
              2019 yil 4 yanvar. O‘zbekiston Respublikasi Prezidentining
              PQ-4091-sonli “O‘zbekiston Respublikasi Vazirlar Mahkamasi
              huzuridagi Mutaxassislarni xorijda tayyorlash va vatandoshlar
              bilan muloqot qilish bo‘yicha “El-yurt umidi” jamg‘armasining
              dasturlari bo‘yicha kadrlarni o‘qitishni tashkil etishni yanada
              takomillashtirish chora-tadbirlari to‘g‘risida” qarorining qabul
              qilinishi.
            </p>
            <p>
              Mazkur qaror bilan “El-yurt umidi” jamg‘armasi faoliyatiga
              quyidagi yangiliklar kiritilgan: stipendiyalar 5 ta tanlov
              o‘tkazish yo‘nalishlari bo‘yicha ajratiladigan bo‘ldi: ta'lim,
              ilmiy tadqiqotlar, sog‘liqni saqlash, davlat boshqaruvi,
              iqtisodiyotning istiqbolli tarmoqlari kesimida, hamda 4 ta ta'lim
              dasturi bo‘yicha: doktorantura, magistratura, stajirovka va malaka
              oshirish; “El-yurt umidi” jamg‘armasi 2019-2021 yillar mobaynida
              jami 4000 o‘ringa stipendiyalar tanlovini e'lon qiladi,
              ajratiladigan kvotalarning kamida 20% doktorantura va magistratura
              ta'lim dasturlari uchun belgilanadi; “El-yurt umidi” jamg‘armasi
              stipendiyalar tanlovlarini tashkil etish mexanizmi va uning
              muddatlari ishlab chiqilgan: vazirliklar, idoralar va tashkilotlar
              ehtiyojlarini o‘rganishdan boshlab toki stipendiatlarga
              sertifikatlar topshirish jarayonlari aniq belgilangan; xalqaro tan
              olingan tashkilotlar reytingiga ko‘ra jahondagi eng yaxshi 500
              talik yoki tanlangan fan yo‘nalishi bo‘yicha eng yaxshi 200 talik
              ro‘yxatiga kirgan xorijiy universitetlar va ilmiy markazlarga
              mustaqil ravishda kirib, o‘qiyotgan O‘zbekiston fuqarolari uchun
              stipendiyalar ajratish amaliyotga kiritilgan; “El-yurt umidi”
              jamg‘armasiga Oliy va o‘rta maxsus ta'lim vazirligi bilan
              birgalikda professor-o‘qituvchilar uchun xorijiy tillarga
              o‘qitishning turli dasturlarini amalga oshirish vazifasi qo‘yilgan
              va boshqalar. 2019-yil 3-oktyabr'. O‘zbekiston Respublikasi
              Prezidentining PF-5843-sonli “O‘zbekiston Respublikasida kadrlar
              siyosati va davlat fuqarolik xizmati tizimini tubdan
              takomillashtirish choralari to‘g‘risida” Farmonining qabul
              qilinishi. Mazkur Farmonga muvofiq O‘zbekiston Respublikasi
              Vazirlar Mahkamasi huzuridagi Mutaxassislarni xorijda tayyorlash
              va vatandoshlar bilan muloqot qilish bo‘yicha “El-yurt umidi”
              jamg‘armasi O‘zbekiston Respublikasi Prezidenti huzuridagi Davlat
              xizmatini rivojlantirish agentligi tarkibiga o‘tkazildi. 2020-yil
              aprel. O‘zbekiston Respublikasi Prezidentining 2020 yil 2 martdagi
              PF-5953–sonli Farmoni bilan tasdiqlangan “Ilm-ma'rifat va raqamli
              iqtisodiyotni rivojlantirish yili” Davlat dasturiga muvofiq
              “Mutaxassislarni xorijda tayyorlashni tashkil etish tizimini
              tubdan takomillashtirish va davlat xizmatchilari salohiyatini
              rivojlantirish to‘g‘risida” Farmoni loyihasining ishlab
              chiqilishi. Mazkur Farmonga ko‘ra 2020 yildan boshlab “El-yurt
              umidi” jamg‘armasi faoliyatida quyidagi yangiliklarni kiritish
              rejalashtirilgan: Jamg‘armaning asosiy ta'lim dasturlari
              mutaxassislarni xorijda doktorantura va magistraturada ta'lim
              olishi, stajirovka o‘tashi va malakasini oshirishi etib
              hisoblanadi;
            </p>
          </div>

          <div className="card5__custom">
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
          </div>
        </div>
      </div>
      <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default Hope;
